import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppLoad } from '@core/contracts/app-load';
import { clearUser, getUser } from '@core/user/store/user.actions';
import { selectUser } from '@core/user/store/user.states';
import { AuthService } from '@core/authentication/services/auth.service';
import { Customer } from '@core/user/utilities/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService implements AppLoad {
  constructor(
    private store: Store,
    private authService: AuthService,
  ) {}

  get(): Observable<Customer> {
    return this.store.select(selectUser);
  }

  load() {
    if (this.authService.isAuthenticated()) {
      this.store.dispatch(getUser());
    }
  }

  clearUser() {
    this.store.dispatch(clearUser());
  }
}
